import { Button, Stack, Tooltip } from "@mantine/core";
import PopOver from "../../../../components/View/PopOver";
import { IconChevronDown, IconDeviceMobileSearch } from "@tabler/icons-react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useState } from "react";
import { transformFilterToServer } from "../../../../functions/utilFunctions";
import { enrichMobilePhoneFilter } from "../../../../api/ContactAPI";
import { notifications } from "@mantine/notifications";

const TableFilterEnrichMobile = ({
  id,
  onFinish,
  selectedIds,
  filter,
  filterResultNumber,
  total,
  withSelection = true,
  withExcludedIds = true,
}) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(null);

  const main = (type, handleClose) => {
    setLoading(type);
    enrichMobilePhoneFilter({
      id: id,
      ids:
        type === "selection_inverse"
          ? []
          : type === "selection"
          ? selectedIds
          : [],
      excluded_ids: type === "selection_inverse" ? selectedIds : [],
      filter:
        type === "selection"
          ? { mode: "or", values: [] }
          : filter?.items?.length > 0 && type !== "selection"
          ? transformFilterToServer(filter)
          : { mode: "or", values: [] },
      export_type: type,
    })
      .then((res) => {
        notifications.show({
          message: lang.contact_lists.enrich_mobile.success,
          color: "green",
        });
        onFinish?.(type);
        handleClose();
      })
      .finally(() => {
        setLoading(null);
      });
  };

  return (
    <PopOver
      opener={(handleOpen, ref) => (
        <Button
          className="to-blue"
          variant="light"
          ref={ref}
          rightSection={<IconChevronDown size={16} />}
          leftSection={<IconDeviceMobileSearch size={18} />}
          onClick={handleOpen}
          justify="start"
          styles={{
            label: {
              marginRight: "auto",
            },
          }}
        >
          {lang.contact_lists.enrich_mobile.label}
        </Button>
      )}
      popoverChildren={(handleClose) => (
        <Stack gap={"xs"}>
          <Tooltip
            label={lang.contact_lists.delete_contacts.no_filter}
            disabled={filter?.items?.length > 0}
          >
            <Button
              loading={loading === "filter"}
              onClick={() => main("filter", handleClose)}
              disabled={!filter || filter?.items?.length < 1}
              variant="subtle"
              size="sm"
              color="tertiary.8"
            >
              {lang.contact_lists.enrich_mobile.filter}{" "}
              {filter?.items?.length > 0 ? `( ${filterResultNumber} )` : ""}
            </Button>
          </Tooltip>
          {withSelection && (
            <Tooltip
              label={lang.contact_lists.delete_contacts.no_selection}
              disabled={selectedIds?.length > 0}
            >
              <Button
                loading={loading === "selection"}
                onClick={() => main("selection", handleClose)}
                disabled={!selectedIds || selectedIds?.length < 1}
                variant="subtle"
                size="sm"
                color="tertiary.8"
              >
                {lang.contact_lists.enrich_mobile.selection}{" "}
                {selectedIds?.length > 0 ? `( ${selectedIds.length} )` : ""}
              </Button>
            </Tooltip>
          )}
          {withExcludedIds && (
            <Tooltip
              label={lang.contact_lists.delete_contacts.no_selection}
              disabled={selectedIds?.length > 0}
            >
              <Button
                loading={loading === "selection_inverse"}
                onClick={() => main("selection_inverse", handleClose)}
                disabled={!selectedIds || selectedIds?.length < 1}
                variant="subtle"
                size="sm"
                color="tertiary.8"
              >
                {lang.contact_lists.enrich_mobile.selection_inverse}{" "}
                {selectedIds?.length > 0
                  ? `( ${filterResultNumber - selectedIds.length} )`
                  : ""}
              </Button>
            </Tooltip>
          )}
          <Button
            loading={loading === "all"}
            onClick={() => main("all", handleClose)}
            variant="subtle"
            size="sm"
            color="tertiary.8"
          >
            {lang.contact_lists.enrich_mobile.all_list}{" "}
            {total ? `(${total})` : ""}
          </Button>
        </Stack>
      )}
      TransitionProps={{
        timeout: 0,
      }}
    />
  );
};

export default TableFilterEnrichMobile;
